/**
 * Timezone-safe date and time utilities for Action Planner & Calendar Projections.
 */

export function startOfDay(date: Date | number): number {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

export function endOfDay(date: Date | number): number {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d.getTime();
}

export function startOfWeek(date: Date | number, startOnMonday = true): number {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (startOnMonday ? (day === 0 ? -6 : 1) : 0);
  d.setDate(diff);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

export function endOfWeek(date: Date | number, startOnMonday = true): number {
  const start = startOfWeek(date, startOnMonday);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  end.setHours(23, 59, 59, 999);
  return end.getTime();
}

export function startOfMonth(date: Date | number): number {
  const d = new Date(date);
  d.setDate(1);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

export function endOfMonth(date: Date | number): number {
  const d = new Date(date);
  d.setMonth(d.getMonth() + 1, 0);
  d.setHours(23, 59, 59, 999);
  return d.getTime();
}

export function formatTimeRange(startMs: number, endMs: number, timeZone?: string): string {
  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone,
  };
  const startStr = new Intl.DateTimeFormat('en-US', options).format(new Date(startMs));
  const endStr = new Intl.DateTimeFormat('en-US', options).format(new Date(endMs));
  return `${startStr} – ${endStr}`;
}

export function formatDateHeading(dateMs: number, timeZone?: string): string {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone,
  }).format(new Date(dateMs));
}

export function isSameDay(date1Ms: number, date2Ms: number): boolean {
  const d1 = new Date(date1Ms);
  const d2 = new Date(date2Ms);
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}
